import React from 'react';
import { AttentionTriangleIcon } from '@rsos/assets/icons';
import { Box, Button } from '@rsos/components/capstone/base';
import { IsFetchErrorContainer, ErrorText } from './PairAuthorityModal.styles';

const isFetchError = ({ error, retryFetchAvailableAgencies }) => {
  const formattedError =
    error && typeof error === 'string'
      ? error
      : 'There was an error fetching agencies';
  return (
    <IsFetchErrorContainer>
      <Box horizontal flow={7} color="lightDanger" align="center">
        <AttentionTriangleIcon height={14} width={14} />
        <ErrorText>{formattedError}</ErrorText>
      </Box>
      <Button
        btnType="secondary"
        size="small"
        onClick={retryFetchAvailableAgencies}
      >
        Retry
      </Button>
    </IsFetchErrorContainer>
  );
};

export default isFetchError;
